import {connect} from 'react-redux';
import Step6 from './Step6';
import {submitStep} from '../../actions/submitStep';
import {uploadFile} from '../../actions/uploadFile';
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";

const mapStateToProps = ({
                           regType: {regType},
                           stepPayload: {payload},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  payload,
  prevCompletedStepSign
});

export default connect(
  mapStateToProps,
  {submitStep, uploadFile, prevCompletedStepSignFalse}
)(Step6);
